import { render, staticRenderFns } from "./PopoverPartnerStatus.vue?vue&type=template&id=86d01cb8&scoped=true&"
import script from "./PopoverPartnerStatus.vue?vue&type=script&lang=js&"
export * from "./PopoverPartnerStatus.vue?vue&type=script&lang=js&"
import style0 from "./PopoverPartnerStatus.vue?vue&type=style&index=0&id=86d01cb8&prod&lang=css&"
import style1 from "./PopoverPartnerStatus.vue?vue&type=style&index=1&id=86d01cb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d01cb8",
  null
  
)

export default component.exports